import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  NetworkIndicatorComponent
} from '../shared/standalone-components/components/network-indicator/network-indicator.component';
import {ToastrComponent} from '../shared/standalone-components/toastr/toastr.component';
import {ReloadBannerComponent} from '../shared/standalone-components/components/reload-banner/reload-banner.component';
import {ModalsModule} from '../shared/modals/modals.module';

@Component({
  selector: 'root',
  imports: [RouterOutlet, ModalsModule, NetworkIndicatorComponent, ToastrComponent, ReloadBannerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  protected readonly title = signal('crp-bor-frontend');
}
